import Tag from "./Tag";
import styled from "styled-components";

const Header = styled.h1`
  width: 100%;
`;

export { Header, Tag };
